module.exports = __webpack_public_path__ + "static/img/support-article-not-found.989cf406.webp";